<template>
  <WsMain>
    <WsCRUD
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :showFields="showFields"
      :pageMode="true"
      :showExpand="false"
      :inRowBtnRead="true"
      :rowClickRead="true"
      :liveSearching="true"
      :isMultiSelect="true"
    >
    </WsCRUD>
  </WsMain>
</template>

<script>
import model from "@/models/app";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    showFields: [
      "id",
      "name",
      "updated_admin",
      "updated_at",
      "created_admin",
      "created_at",
    ],
  }),
};
</script>

<style>
</style>